export default __webpack_public_path__ + "static/media/www.19516ffa.svg";